<template>
<div>
<b>test component</b>
</div>
</template>

<script>
  export default {
    name: 'TestBox',
    data: () => ({ 
    }),
  }
</script>
